module.exports = __webpack_public_path__ + "static/DevOps-Iphone-ffca8d07ee323c3e6cf140a09fdba0d6.mp4";